export default __webpack_public_path__ + "static/media/resume.4a3080f1.pdf";